import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { AccordionContext, useAccordionButton } from 'react-bootstrap';

export const Toggle = ({ children, eventKey }) => {
	const currentEventKey = useContext(AccordionContext);
	return (
		<a onClick={useAccordionButton(eventKey)}>
			{children}
			<span
				className={
					'icon ' + (eventKey === currentEventKey ? 'active' : '')
				}
			>
				<FontAwesomeIcon icon={faPlus} size="1x" />
			</span>
		</a>
	);
};
